import { DocumentConnection } from '../../common/model/document-connection-base';
import { ContactDocumentType, ContactDocumentTypeToString } from './const/documentEnums';

export class ContactDocument extends DocumentConnection<ContactDocumentType> {
  constructor() {
    super();
  }

  get connectionTypeText(): string {
    return ContactDocumentTypeToString(this.connectionType);
  }

  contactId: string;

  toJSON() {
    const result = super.toJSON();
    result['contactId'] = this.contactId;
    return result;
  }
}
